import { render, staticRenderFns } from "./CredoresHome.vue?vue&type=template&id=ac143ed8"
import script from "./CredoresHome.vue?vue&type=script&lang=js"
export * from "./CredoresHome.vue?vue&type=script&lang=js"
import style0 from "./CredoresHome.vue?vue&type=style&index=0&id=ac143ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports